import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const FaxKeys = createQueryKeys("comm_center", {
  search: (params: Record<string, unknown>) => params,
});
